import { ThemeEvents } from '@theme/events';

/**
 * A custom element that wraps the technical specs table and updates
 * variant-dependent fields when the selected variant changes.
 *
 * Rows flagged with `data-variant-field="<name>"` are selectively replaced
 * when a `variant:update` event fires. All other rows remain untouched.
 *
 * Listens on `document` (cross-section pattern) because the variant picker
 * lives in a separate Shopify section (product-information).
 */
class TechnicalSpecsTable extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  #handleVariantUpdate = (event) => {
    const { html, productId } = event.detail.data;

    if (productId && this.dataset.productId && productId !== this.dataset.productId) {
      return;
    }

    const newTable = html.querySelector('technical-specs-table');
    if (!newTable) return;

    const currentFields = this.querySelectorAll('[data-variant-field]');

    for (const currentRow of currentFields) {
      const fieldName = currentRow.getAttribute('data-variant-field');
      const newRow = newTable.querySelector(`[data-variant-field="${fieldName}"]`);

      if (newRow) {
        currentRow.replaceWith(newRow.cloneNode(true));
      }
    }
  };
}

if (!customElements.get('technical-specs-table')) {
  customElements.define('technical-specs-table', TechnicalSpecsTable);
}
